import Application from '../../Application'
import ScorocodeError from '../../utils/ScorocodeError'
import { ICollection, ICollectionPayload } from '../client/PGManager'
import Document from './Document'
import Query from './Query'

export default class Collection {
  private _info?: ICollection

  constructor(
    public readonly app: Application,
    public readonly db: string,
    public readonly schema: string,
    public readonly ref: string
  ) {}

  // getters
  get info(): ICollection | void {
    return this._info
  }

  // factories
  document(id?: string): Document {
    return new Document(this.app, this.db, this.schema, this.ref, id)
  }

  query(): Query {
    return new Query(this.app, this.db, this.schema, this.ref)
  }

  // api
  drop(): Promise<this> {
    return this.app
      .client()
      .pgManager.dropCollection(this.db, this.schema, this.ref)
      .then(() => {
        this._info = undefined

        return this
      })
  }

  create(options: ICollectionPayload): Promise<this> {
    return this.app
      .client()
      .pgManager.createCollection({
        ...options,
        dbId: this.db,
        name: this.ref,
      })
      .then((info) => {
        this._info = info

        return this
      })
  }

  sync(): Promise<this> {
    return this.app
      .client()
      .pgManager.getCollectionsInfo(this.db, this.schema, this.ref)
      .then((collection) => {
        this._info = collection

        return this
      })
  }

  // must return unsubscribe function
  realSync(
    onChange: (collection: Collection) => void,
    onError: (error: ScorocodeError) => void
  ) {
    // todo
    onChange(this)
  }
}
